import "./case.scss";
import impressions from "./assets/impressions.png";
import engagement from "./assets/engagement.png";
import resulted from "./assets/resulted-in.png";
import poster from "./assets/poster.jpeg";
import { fade } from "../fade.js";
import { motion } from "framer-motion";

import title from "./assets/title.png";
const video_Url =
  "https://prismic-io.s3.amazonaws.com/goodstuph/54c0a2b7-1cec-462b-92a3-c9025020ee60_campaign.mp4";

const Case = () => {
  return (
    <section className="section case">
      <motion.img
        src={title}
        className="title"
        alt="Watch How we took over jakarta"
        variants={fade}
        initial="hide"
        whileInView="show"
        viewport={{ once: true }}
      />
      <motion.video
        controls
        className="case-study-video"
        variants={fade}
        poster={poster}
        initial="hide"
        whileInView="show"
        viewport={{ once: true }}
        preload="metadata"
      >
        <source src={video_Url} type="video/mp4" />
      </motion.video>
      <motion.div
        className="results"
        variants={fade}
        initial="hide"
        whileInView="show"
        viewport={{ once: true }}
      >
        <div className="row">
          <img
            src={resulted}
            alt="The heist resulted in"
            className="title-result"
          />
        </div>
        <div className="row small">
          <div className="column-left">
            <img src={impressions} alt="Impressions" />
          </div>
          <div className="column-right">
            <img src={engagement} alt="Engagements" />
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default Case;
